module.exports = __webpack_public_path__ + "static/background-c91ee795ed1dd42b0c0d531dba5243ee.png";